import { CnLayoutPagePrototype } from './cn-layout-page/prototype';
import { CnLayoutCellPrototype } from './cn-layout-cell/prototype';
import { CnLayoutHeaderPrototype } from './cn-layout-header/prototype';
import { CnLayoutContentPrototype } from './cn-layout-content/prototype';
import { CnLayoutSectionPrototype } from './cn-layout-section/prototype';
import { CnLayoutRowPrototype } from './cn-layout-row/prototype';
import { CnLayoutColPrototype } from './cn-layout-col/prototype';
import { CnLayoutAsidePrototype } from './cn-layout-aside/prototype';
import { CnLayoutBlockPrototype } from './cn-layout-block/prototype';
// 通过arr控制输出的顺序
const bundle = [
    CnLayoutPagePrototype,
    CnLayoutCellPrototype,
    CnLayoutHeaderPrototype,
    CnLayoutContentPrototype,
    CnLayoutSectionPrototype,
    CnLayoutRowPrototype,
    CnLayoutColPrototype,
    CnLayoutAsidePrototype,
    CnLayoutBlockPrototype,
];
export default bundle;
